<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">{{ titulo }}</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblDespegasGerais"
                            :itens="despesas"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="status" slot-scope="data">
                                <app-status :status="data.status"></app-status>
                            </template>
                            <template slot="dataVencimento" slot-scope="data">
                                {{ data.dataVencimento != null ? $moment(data.dataVencimento).format('DD/MM/YYYY') : '' }}
                                <btn-justificativa-data-vencimento
                                    :despesa="data"
                                ></btn-justificativa-data-vencimento>
                            </template>
                            <template slot="boleto" slot-scope="data">
                                <app-status :status="data.boleto ? 'SIM' : 'NÃO'"></app-status>
                                <slot name="boleto" v-bind="data"></slot>
                            </template>
                            <template slot="idMov" slot-scope="data">
                                {{ data.idMov }}
                                <status-id-mov :despesa="data"></status-id-mov>
                            </template> 
                            <template slot="valor" slot-scope="data">
                                {{ data.valor | currency }}
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <slot name="despesaAcoes" v-bind="data"></slot>
                            </template>
                            <template
                                slot="despesaSelecao"
                                slot-scope="data"
                                v-if="incluirSelecao"
                            >
                                <slot name="despesaSelecao" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>    
</template> 

<script>
import StatusIdMov from './StatusIdMov.vue';
import BtnJustificativaDataVencimento from './BtnJustificativaDataVencimento.vue';

export default {
    props: {
        despesas: {
            type: Array,
            default: () => []
        },
        
        incluirSelecao: {
            type: Boolean,
            default: false
        },

        titulo: {
            type: String,
            default: 'Despesas'
        },

        servicos: {
            type: Object,
            default: () => ({})
        },
        
        removerAcao: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        BtnJustificativaDataVencimento,
        StatusIdMov
    },

    created() {
        if (this.incluirSelecao) {
            this.campos.unshift({
                key: 'despesaSelecao',
                label: ''
            })
        }

        if (this.removerAcao) {
            this.campos.pop()
        }
    },

    data() {
        return {
            itensPorPagina: 5,
            campos: [
                {   
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'sequencial',
                    label: 'Sequencial',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'numeroNota',
                    label: 'Número da Nota',
                    sortable: true,
                    filterable: true
                },
                {   
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {   
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {   
                    key: 'dataVencimento',
                    label: 'Data do Vencimento',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'boleto',
                    label: 'Boleto',
                    sortable: true,
                },
                {
                    key: 'qtdItens',
                    label: 'Itens',
                    tdClass: 'text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'status',
                    label: 'Status',
                    tdClass: 'text-center'
                },
                {
                    key: 'idMov',
                    label: 'Comprometimento',
                    filterable: true
                },
                {
                    key: 'codNomeTipoMovimento',
                    label: 'Tipo Movimento',
                    filterable: true
                },
            ]
        }
    }
}

</script>